import fieldsArrSheet from 'fields/FieldsArrSheet';

export default {
  Exhibitions: {
    // root
  },
  ...fieldsArrSheet,
};
